import { render, staticRenderFns } from "./error.modal.vue?vue&type=template&id=4e28e62c&"
import script from "./error.modal.vue?vue&type=script&lang=ts&"
export * from "./error.modal.vue?vue&type=script&lang=ts&"
import style0 from "./error.modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports